/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { CaptchaElements } from "../Constants/CaptchaConstants";
import { findCaptchaBlock } from "../Utils/CaptchaUtils";
var CaptchaRender = /** @class */ (function () {
    function CaptchaRender() {
    }
    CaptchaRender.renderCaptcha = function (placeholder) {
        var captchaBlock = findCaptchaBlock([placeholder]);
        if (captchaBlock) {
            captchaBlock.innerHTML = CaptchaRender.getCaptchaContent();
        }
    };
    CaptchaRender.getCaptchaContent = function () {
        return "<div id=\"".concat(CaptchaElements.hipId, "\"></div>\n        <div id=\"").concat(CaptchaElements.hipScriptId, "\" style=\"display: inline\"></div>\n        <div style=\"display: none\">\n          <input\n            id=\"").concat(CaptchaElements.solutionId, "\"\n            name=\"").concat(CaptchaElements.solutionId, "\"\n            type=\"hidden\"\n          />\n          <input\n            id=\"").concat(CaptchaElements.typeId, "\"\n            name=\"").concat(CaptchaElements.typeId, "\"\n            type=\"hidden\"\n          />\n          <input\n            id=\"").concat(CaptchaElements.captchaFlowId, "\"\n            name=\"").concat(CaptchaElements.captchaFlowId, "\"\n            type=\"hidden\"\n          />\n        </div>");
    };
    return CaptchaRender;
}());
export { CaptchaRender };
